import { Modal, Text } from '@ui/themed';
import { t } from 'i18next';

/**
 * Advanced features can't be set up from the Shopify app, so clicking one offers a trip to the
 * dashboard instead of running the action here.
 */
export function AdvancedFeatureModal({
  isOpen,
  closeModal,
  featureName,
  onConfirm,
}: {
  isOpen: boolean;
  closeModal: () => void;
  featureName: string;
  onConfirm: () => void;
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={closeModal}
      primaryAction={{
        text: t('buttons:go_to_dashboard'),
        onClick: () => {
          onConfirm();
          closeModal();
        },
      }}
      secondaryAction={{
        text: t('buttons:cancel'),
        onClick: closeModal,
      }}
    >
      <Modal.Header>{t('features:explore.components.advanced_feature_modal.title')}</Modal.Header>
      <Modal.Body>
        <Text variant="secondary" size="md">
          {t('features:explore.components.advanced_feature_modal.body', {
            feature: featureName,
          })}
        </Text>
      </Modal.Body>
    </Modal>
  );
}
